import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { CsrfTokenService } from '../services/csrf-token.service';

export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
  const csrfTokenService = inject(CsrfTokenService);

  if (req.url.includes('/csrf-token')) {
    return next(req);
  }

  return from(csrfTokenService.fetchCsrfToken()).pipe(
    switchMap((csrfToken) => {
      if (csrfToken) {
        const clonedReq = req.clone({
          setHeaders: {
            'X-XSRF-TOKEN': csrfToken,
          },
        });

        return next(clonedReq);
      }

      return next(req);
    })
  );
};

